import React from 'react';
import { TrendingUp } from 'lucide-react';
import { industries } from '../../data/mockData';
import IndustriesCarousel from '../IndustriesCarousel';

const IndustriesSection = () => (
  <section className="py-16 md:py-24 bg-white relative overflow-hidden">
    <div className="absolute inset-0 opacity-20">
      <div className="absolute top-0 left-0 w-96 h-96 bg-cyan-500/20 rounded-full blur-3xl animate-pulse" />
      <div
        className="absolute bottom-0 right-0 w-96 h-96 bg-blue-500/20 rounded-full blur-3xl animate-pulse"
        style={{ animationDelay: '1s' }}
      />
    </div>

    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-16">
        <div className="inline-flex items-center space-x-2 px-4 py-2 bg-purple-50 border border-purple-200 rounded-full mb-4">
          <TrendingUp className="h-4 w-4 text-purple-600" />
          <span className="text-purple-600 text-sm font-medium">Industry Expertise</span>
        </div>
        <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-gray-900 mb-4">Industries We Serve</h2>
        <p className="text-base md:text-xl text-gray-600 max-w-2xl mx-auto">
          Providing safety solutions across diverse industrial sectors
        </p>
      </div>

      <IndustriesCarousel industries={industries} />
    </div>
  </section>
);

export default IndustriesSection;
